export default __webpack_public_path__ + "static/media/checklist.d3cc1f31.svg";